import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import AOS from 'aos';
import '@fortawesome/fontawesome-free/css/all.css';
import './assets/tailwind.css'

AOS.init({
  once: true, // Animation only once
  duration: 1000, // Duration par défaut
});
createApp(App).use(store).use(router).mount('#app')
